import axios from "@/api/config";

const videoInfo = {
  getVideoInfoById(data) {
    return axios.get(
      `${process.env.BASE_URL}/videoInfo/getVideoInfo/` + data,
      {}
    );
  },
  getVideoInfo(data) {
    return axios.get(`${process.env.BASE_URL}/videoInfo/getVideoInfo`, {
      params: data
    });
  },
  getVideoInfoList(data) {
    return axios.get(`${process.env.BASE_URL}/videoInfo/getVideoInfoList`, {
      params: data
    });
  },
  getVideoInfoTree(data) {
    return axios.get(`${process.env.BASE_URL}/videoInfo/getVideoInfoTree`, {
      params: data
    });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/videoInfo/pageList`, data);
  },
  addVideoInfo(data) {
    return axios.post(`${process.env.BASE_URL}/videoInfo/addVideoInfo`, data);
  },
  updateVideoInfo(data) {
    return axios.put(`${process.env.BASE_URL}/videoInfo/updateVideoInfo`, data);
  },
  deleteVideoInfo(data) {
    return axios.delete(`${process.env.BASE_URL}/videoInfo/deleteVideoInfo`, {
      data: data
    });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/videoInfo/exportExcel`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/videoInfo/importData`, data);
  },
  syncTencent(data) {
    return axios.get(`${process.env.BASE_URL}/videoInfo/syncTencent`, {
      params: data
    });
  },
  getTecent(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoInfo/getTencentVideo`,
      data
    );
  },
  bindTencent(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoInfo/bindTencentVideo`,
      data
    );
  },
  updateVideoInfoByAttachmentList(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoInfo/updateVideoInfoByAttachmentList`,
      data
    );
  },
  updateTencentVideoId(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoInfo/updateTencentVideoId`,
      data
    );
  },
  updateVideoInfoCourseInfoSort(data) {
    return axios.post(
      `${process.env.BASE_URL}/videoInfo/updateVideoInfoCourseInfoSort`,
      data
    );
  },
  //绑定试题
  bindQuestionBatchVideo(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/bindQuestionBatchVideo`,
      data
    );
  },
  //解绑试题
  deleteVideoQuestion(data) {
    return axios.post(
      `${process.env.BASE_URL}/question/deleteVideoQuestion`,
      data
    );
  },
  // 题库范围更新
  updateGoodsItem(data) {
    return axios.put(`${process.env.BASE_URL}/goodsItem/updateGoodsItem`, data);
  },
  // 批量更新试看
  updateTryUse(data) {
    return axios.post(`${process.env.BASE_URL}/videoInfo/updateTryUse`, data);
  },
  addSubjectVideo(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectVideo/addSubjectVideo`,
      data
    );
  },

  getSubjectVideoTree(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectVideo/getSubjectVideoTree`,
      { params: data }
    );
  },
  delSubjectVideo(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectVideo/delSubjectVideo`,
      data
    );
  },
  delSubjectVideoRelation(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectVideoRelation/delSubjectVideoRelation`,
      data
    );
  },

  videoShowWay(data) {
    // tiaojia
    return axios.post(
      `${process.env.BASE_URL}/videoShowWay/videoShowWay`,
      data
    );
  },
  addSubjectVideoRelation(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectVideoRelation/addSubjectVideoRelation`,
      data
    );
  },
  updateSubjectVideoRelation(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectVideoRelation/updateSubjectVideoRelation`,
      data
    );
  },
  updateSubjectVideo(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectVideo/updateSubjectVideo`,
      data
    );
  },
  updateVideoInfoSort(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectVideo/updateVideoInfoSort`,
      data
    );
  },
  getVideoShowWay(data) {
    return axios.get(`${process.env.BASE_URL}/videoShowWay/getVideoShowWay`, {
      params: data
    });
  }
};

export default videoInfo;



// WEBPACK FOOTER //
// ./src/api/videoInfo.js